// ============================================================
// 简体中文翻译 — 米其林酒庄 (Les Combes Cachées)
// SIMPLIFIED CHINESE TRANSLATIONS — Domaine Michelin
// ============================================================

export const zh = {
  // ─── 导航栏 NAVBAR ────────────────────────────────────────
  navbar: {
    home: "首页",
    story: "品牌故事",
    winery: "酒庄",
    wines: "葡萄酒",
    contact: "信息与联系",
  },

  // ─── 首页 HERO ────────────────────────────────────────────
  hero: {
    coverText: [
      "朗格多克核心的有机酒庄",
      3000,
      "品质至上",
      2500,
      "匠心规模",
      2500,
    ],
    cta: "探索我们的故事",
    videoCta: "观看完整视频",
    resumeToWebsite: "返回网站",
  },

  // ─── 品牌故事 STORY ───────────────────────────────────────
  story: {
    sectionTitle: "品牌故事",
    teamHeaderTitle: "一段激情的故事",
    storyTitle: "从骑行到酿酒的旅程",
    storyBody: [
      { text: "米其林酒庄 — Les Combes Cachées", highlight: true },
      {
        text: "，是三位老友梦想成真的结晶：Xavier Michelin、Michel Pousse 和 François Aumonier。他们同来自法国西南部图卢兹附近的同一个村庄。尽管背景各异，他们始终共享同一份热情——葡萄酒！二十年间，Michel 与 Xavier 骑行穿越法国各大著名酒区（骑行是他们共同的另一大爱好！）。直至某日，在两次踏板之间的品鉴时刻，他们决定拥有并经营自己的酒庄。历经两年寻觅，终于找到了心中理想之地——",
      },
      {
        text: "位于米内瓦产区核心的 La Livinière 优质风土",
        highlight: true,
      },
      {
        text: "，距中世纪名城卡尔卡松仅 30 公里。François 是第三位伙伴，在听闻两位好友的发现后立即加入了这段冒险。三人共同将其命名为'Les Combes Cachées'（'隐秘山谷'），以致敬这片孕育梦想的壮美风景。三人组随即携手当地经验丰富的酿酒师，正式踏上征程。在亲友的支持、辛勤的劳作与满腔热忱下，Les Combes Cachées 的第一个年份于 2015 年问世，立即获得评论界的广泛关注。这是一段由激情与友谊引领、追求卓越与精益求精的精彩旅程的起点。",
        highlight: false,
      },
    ],

    // Xavier
    xavierName: "Xavier Michelin",
    xavierText: [
      "Xavier Michelin 是安德烈·米其林的第四代直系后裔，这一家族遗产长久以来与卓越、创新和开拓精神紧密相连。",
      "数代以来，米其林这个名字承载着一种核心价值：企业家精神。对世界的好奇、对创新的热爱，以及着眼长远的承诺，塑造了家族每一代人的精神风貌。",
      "在这份家族遗产的引领下，Xavier 在农业领域走出了自己的道路。在图卢兹地区从事了三十余年的谷物种植后，他决定追寻新的梦想。2015 年，他与两位挚友 Michel 和 François 共同创立了米其林酒庄 — Les Combes Cachées。",
      "米其林故事的这一新篇章，在一片非凡的土地上徐徐展开：朗格多克的葡萄园。在连绵的丘陵、芬芳的马基灌木丛和富含矿物质的土壤之间，创始人们共同孕育出了一个独特而雄心勃勃的项目。",
      "从创立之初，酒庄便以清晰的愿景为引领——追求卓越，酿造兼具精准、优雅与真实感的葡萄酒。每一个决策都折射出对品质的不懈追求，在此，传承与精致相遇，每款葡萄酒都表达着风土与卓越哲学的交融。",
      "米其林不仅是一个名字——它是企业家传承的延续，是卓越的印记，更是一份探索法国精致酿酒工艺的诚挚邀请。",
    ],

    // Team detail
    teamDetail: [
      {
        name: "Michel Pousse",
        text: "Michel Pousse 最初是一位地理学博士，在太空工业和气象学（Spot Image、法国气象局国际部）领域拥有三十年的国际商业经验。在米其林酒庄，Michel 现负责酿酒、葡萄酒营销与销售事务。他曾在阿维尼翁附近的 Suze la Rousse 葡萄酒大学接受专业酿酒培训。Michel 热爱这种新生活——如果您路过，很可能会看到他漫步于葡萄园中，凝视着 Les Combes Cachées 土地的独特魅力……这就是地理学家做的事！",
      },
      {
        name: "François Aumonier",
        text: "François Aumonier 最初是一位农学家，曾长期从事高科技营销和企业管理工作。他现在负责米其林酒庄的行政和财务工作。François 最喜欢开玩笑说，与 Xavier 和 Michel 不同，他为酒庄所做的事情微乎其微……除了一些不起眼的琐碎事务，如海关申报、会计以及各类繁琐文书工作——而这些恰恰是 Xavier 和 Michel 最不愿触碰的！",
      },
      {
        name: "Frederic Justeau",
        text: "Frederic Justeau（绰号 Fred）是酒庄的'瑞士军刀'。酒庄生活的方方面面对他来说都没有秘密！从葡萄园的体力劳动到酒窖中精细的酿酒操作，Fred 样样精通。在加入米其林酒庄之前，他曾在新西兰、澳大利亚、南非及法国多个著名酒庄工作。他现在负责葡萄园和酒窖的全部运营工作。他热爱这份工作的多样性，只要他在场，任何问题都会找到解决方案！",
      },
    ],
    afterTrio:
      "尽管 Xavier、Michel 和 François 在米其林酒庄各有所长，但他们始终作为一个团结的整体默契协作，共同做出每一个重要决策……始终铭记，这一切最初都源于一段真挚的友谊。",

    // Oenologists
    oenologistsTitle: "我们的酿酒师团队",
    oenologistsText:
      "自 2020 年起，米其林酒庄与领先的酿酒实验室——位于法国南部纳博讷附近的 Laboratoire Dubernet 建立了合作关系。该实验室在酿酒、陈年和装瓶方面为酒庄提供全方位的专业指导。米其林酒庄得益于三位经验丰富的酿酒师的专业支持：",
    oenologists: [
      { name: "Nicolas Triviaux", text: "酿酒顾问，在智利、加利福尼亚、澳大利亚和法国拥有 13 年酿酒经验。" },
      { name: "Aymeric Laturelle", text: "酿酒师，在波尔多、罗讷河谷、加利福尼亚、西班牙及朗格多克-鲁西永拥有 6 年经验。" },
      { name: "Nicolas Dutour", text: "高级顾问，在法国南部、加利福尼亚和巴西拥有 14 年酿酒经验。" },
    ],

    // Family
    familyTitle: "大家庭",
    familySubtitle: "Boris、Thibault、Etienne、Martin、Christine、Maria 及团队成员……",
    familyText:
      "米其林酒庄始终是一段集体的冒险。当然，有创始人和长期员工……但自创立之初，始终有一批充满爱心的人围绕在这个项目周围，以各自的方式贡献着力量。首先是创始人的家庭成员：\n- Boris 和 Thibault，Xavier 的儿子。他们在葡萄园采摘和酒窖各项工作中付出了大量时间和精力。\n- Martin、Camille 和 Etienne，Michel 的子女。Martin 负责酒窖设备和材料管理，Camille 和 Etienne 则在传播和市场推广方面给予大力支持。还有 Michel 的妻子 Christine，随时准备伸出援手，无论需要什么！\n\n当然，若不提及每年采摘季加入酒庄的临时员工，这幅画面便不完整。多年来，酒庄与 Maria 一家建立了深厚的情谊——他们就住在附近，每年定期参与酒庄的工作，帮助应对采摘季的繁忙高峰。",
    readMore: "阅读更多",
  },

  // ─── 酒庄 WINERY ──────────────────────────────────────────
  winery: {
    sectionTitle: "酒庄",
    mainTitle: "一片卓越的葡萄园",
    items: [
      {
        headerText: "无与伦比的风土",
        alt: "葡萄园中的橡木桶与优质葡萄酒",
        text: "米其林酒庄的独特性在于其所在土地的品质：隐秘的小山谷（'combes'），位于 Causse de Minerve 高原之上，嵌于茂密的马基灌木区中，背靠连绵起伏的 Montagne Noire 南坡，面朝比利牛斯山脉。我们的葡萄藤蜿蜒而下，生长于排水良好、光照充足、覆盖砾石的粘土-石灰岩土壤之上。\n我们的葡萄园分布于 Montagne Noire 的山坡和梯田上，多达 18 个不同地块……开车巡视一圈都需要数小时！这些地块是我们从不同业主手中购得的——那些厌倦了经营偏远小地块的人，我们将它们汇聚，共同创造了米其林酒庄。我们的理念：多样性与品质！每个地块都为最终的混酿赋予独特的个性与风味。\n平均而言，我们的葡萄藤树龄约为 25 年，其中不乏极为古老的佳利酿（1953 年、1969 年）。",
      },
      {
        headerText: "品质为本",
        alt: "Michel 和 Xavier 在葡萄园中进行土壤管理",
        text: "我们在酿酒的每个环节都追求最高品质：\n- 修剪方式根据每块地的特点和葡萄品种分别调整。\n- 采摘日期逐地块决定，以确保葡萄达到最佳成熟度。\n- 葡萄全部手工采摘，并在地块和酒窖两处借助先进的分选台进行严格筛选。\n- 酿酒逐地块进行，配备专属发酵罐，最大程度体现风土的独特表达。\n- 陈年方式因酒而异：Minervois 和白葡萄酒采用不锈钢罐，Livinière 则使用橡木桶。\n- 混酿在陈年结束后进行，Livinière 为采摘后 18 至 24 个月。这是一个对每一个罐和每一只桶进行深度品鉴的过程……始终追求最佳平衡、最细腻的风味与最卓越的品质。",
      },
      {
        headerText: "有机，因信念而生",
        alt: "幼嫩的葡萄生长",
        text: "我们的目标很简单：酿造高品质、个性鲜明且对珍贵环境绝对尊重的葡萄酒。我们相信，只有这样，风土才能充分展现其所有潜力。因此，从创立之初，米其林酒庄便以有机方式运营。无论是葡萄园还是酒窖，我们从未使用任何化学制品。2018 年，我们所有产品均获得了官方有机认证。",
      },
      {
        headerText: "先进的酒窖",
        alt: "酒庄中存放橡木桶的酒窖",
        text: "从零开始，我们不得不购置或建设自己的酒窖。我们有幸收购并翻新了 Siran 葡萄酒合作社的旧蒸馏厂——这座建于 1904 年的石砌建筑，具有典型的南法二十世纪葡萄酒合作社建筑风格。它已闲置数十年。我们对其进行了全面修缮，打造出一座现代化酒窖，专为酿酒与陈年而设计。酒窖目前配备了连接所有不锈钢发酵罐的综合冷却系统，确保发酵过程在理想温度下进行。储酒空间和桶陈室均配有独立空调系统，以在陈年和储存期间维持适宜温度。",
      },
      {
        headerText: "酿酒的艺术",
        alt: "白葡萄酒、桃红葡萄酒和红葡萄酒",
        text: "米其林酒庄的酿酒始于每个地块在最佳成熟度时的采收。白葡萄酒直接进行整串压榨；红葡萄酒则在使用先进分选台精细筛选后去梗破碎。发酵在不锈钢罐中进行，温度受到精确控制。浸渍方案、发酵时长及相关操作逐地块、逐罐决定，以每日品鉴为依据……混酿在陈年结束后、装瓶前进行，以从每个年份中汲取最精华的部分。\n白葡萄酒和 Minervois 红葡萄酒在不锈钢罐中陈年。Minervois 白葡萄酒在酒泥上陈年，并定期搅桶。Minervois-La Livinière 特级园则在 300 升法国橡木桶中陈年。",
      },
    ],
    coreValuesTitle: "我们的核心理念",
    galleryTitle: "画廊",
    readMore: "阅读更多",
  },

  // ─── 葡萄酒 WINES ─────────────────────────────────────────
  wines: {
    sectionTitle: "葡萄酒",
    categories: ["米内瓦 Minervois", "利维尼埃特级园", "其他"],
    overviews: [
      { title: "米内瓦 Minervois", text: "两款不同风格的 Minervois AOP 葡萄酒，各具独特个性。" },
      { title: "利维尼埃特级园", text: "三款不同风格的 Cru La Livinière AOP 葡萄酒，风格迥异，各有千秋。" },
      { title: "其他", text: "白葡萄酒与限量小批次系列。" },
    ],
    wines: [
      { headerText: "Soleil Rouge（红日）", text: "Soleil Rouge 在保留利维尼埃特级园典雅风骨的同时，展现出鲜活的果味与丝绒般的口感。这是一款无需等待、年轻即可享用的利维尼埃佳酿，兼具厚度与清新。其秘诀在于两点：有限使用三年旧橡木桶，以及在最终混酿中加入仙梭（Cinsault），为酒液赋予更多活泼的果味……结果令人满意：Soleil Rouge 呈现出现代、迷人的利维尼埃特级园风格。" },
      { headerText: "Les Trois Ecus（三徽章）", text: "Les Trois Écus 是米其林酒庄利维尼埃特级园的经典之作。优雅而果味丰沛，口感饱满且余韵悠长。该酒经至少 18 个月陈年，其中 12 个月在 300 升法国橡木桶中度过，每年更换三分之一新桶。新桶的甄选每年都十分严格，须与当年年份的特点相契合。我们的目标是挑选出能为葡萄酒增添复杂度和陈年潜力、同时不遮掩果香的橡木桶。Les Trois Écus 上市即可饮用，但若您足够耐心，亦可在自家酒窖中继续窖藏。" },
      { headerText: "Générations（传承）", text: "Générations 是我们'顶级年份特选'的品牌名称，代表特定年份中我们所能酿造的最卓越之作。每款 Cuvée 的命名取决于当年：'Axel'（2015年）、'Elias'（2016年）、'Yuna'（2017年）、'Malone'（2018年）、'Anouk'（2020年）——这些都是近年出生的孙辈们的名字。这是我们的幸运……\n这一系列每年从年份中精选出最优秀的橡木桶，产量极为有限：仅 800 至 1000 瓶。在年份陈年结束时，我们逐一品鉴每只桶，年年都能发现宝藏：某些桶的品质卓越，成就了顶级的混酿。Générations 因此是一款极为独特的 Cuvée，每年各具风采，且每年都是巅峰之作。" },
      { headerText: "La Curiosité de Lauriole（洛里奥的好奇）", text: "'La Curiosité de Lauriole'是我们产区的一处旅游名胜，也是这款 Cuvée 的葡萄藤所在地。这款酒提供即时的品鉴愉悦，拥有浓郁的红色果实香气与甜润的口感。这是一款适合餐前开胃或搭配烤肉的轻松葡萄酒，也可在夏季轻度冰镇至 14° 享用……通过部分整串浸渍酿造，最大程度萃取香气。" },
      { headerText: "Hauts de Siran（悉朗高地）", text: "'Les Hauts de Siran'是一款慷慨的佳酿，拥有浓郁的红色和黑色水果香气与香料气息。口感强劲悠长，饱满而甜润。这是一款极具魅力的朗格多克葡萄酒，可单独享用，亦可搭配各类美食。'Les Hauts de Siran'展现出来自海拔 300 米高地葡萄园的独特清新感，搭配独特风土与理想的成熟度。" },
      { headerText: "Combe Violon（琴谷）", text: "'Combe Violon'是我们其中一处'隐秘山谷'的名称，隐藏于马基灌木丛中，孕育着一款珍稀之作：半公顷的白歌海娜（White Grenache）与瑚珊（Roussanne）。海拔 350 米的清新通风风土与石灰岩土壤，造就了一款矿物感强、优雅而持久的白葡萄酒，散发着白花与水果的迷人芬芳。产量极为有限（年均约 2000 瓶）。这是一款典型的美食级葡萄酒，非常适合搭配精致菜肴，如鱼类、白肉、山羊奶酪……" },
      { headerText: "La Martelle & Le Bois de La Martelle", text: "'La Martelle'是我们用于酿造 100% 维欧尼（Viognier）葡萄酒的地块名称。这片风土位于利维尼埃特级园分级之内，极佳的风土却种植了维欧尼。这款白葡萄酒易饮、清新、果味充沛且酒体丰满，非常适合单独饮用，或搭配各类夏日美食、鱼类、奶酪。我们同样以同一地块的葡萄酿造了一款名为'Le Bois de la Martelle'的橡木桶陈年版（400 升）。桶陈使酒液更为复杂浓郁，同时保持了清新的果味，展现出典型的美食级风格……" },
      { headerText: "Small Cuvées（小批次系列）", text: "每一年，我们都会根据心情与年份条件，尝试酿造限量小批次 Cuvée：Minervois 桃红葡萄酒、以维欧尼酿制的甜酒，或来自 La Galine 美丽风土的 100% 佳利酿。这些均为限量版，每款不足 1000 瓶，纯粹为了我们自己的乐趣与您的好奇而酿造，并在本地市场销售给我们的客户。欢迎前来拜访，我们很乐意与您分享……" },
    ],
    ourWinesTitle: "我们的葡萄酒",
    seeWines: "查看酒款",
    readMore: "阅读更多",
  },

  // ─── 联系 CONTACT ─────────────────────────────────────────
  contact: {
    sectionTitle: "信息与联系",
    cardTitle: "米其林酒庄 — Les Combes Cachées",
    cardText:
      "自创立以来，我们的葡萄酒已销往全球多个大洲和众多国家：美洲（美国、加拿大、墨西哥），欧洲（比利时、德国、荷兰、瑞典、挪威、塞尔维亚），以色列，亚洲（日本和中国）。如有任何咨询，请发送电子邮件至 domainemichelin@gmail.com。",
    emailButton: "发送邮件",
  },

  // ─── SEO 元数据 SEO META ───────────────────────────────────
  seo: {
    title: "米其林酒庄 — Les Combes Cachées | 朗格多克有机酒庄",
    description:
      "探索米其林酒庄 — Les Combes Cachées，位于法国朗格多克-米内瓦的有机酒庄。出口至美洲、欧洲及亚洲的利维尼埃特级园精品葡萄酒。",
  },

  // ─── 媒体评述 TESTIMONIALS ──────────────────────────────────
  testimonials: {
    header: "媒体评述...",
    items: [
      {
        title: "朗格多克明珠：24款米内瓦-利维尼埃葡萄酒品鉴",
        badge: "首选推荐",
        text: "米其林酒庄的 Cuvée Axel 同样令人印象深刻。2015年份仅限量生产 730 瓶，由该年份最出色的三个橡木桶混酿而成。这款酒由佳利酿 (5%)、仙梭 (10%)、歌海娜 (20%) 和西拉 (65%) 酿制，结构严谨，香气浓郁，极具个性。",
      },
      {
        title: "米内瓦 利维尼埃",
        badge: "顶级生产商",
        text: "米内瓦利维尼埃：地处内陆高地，以石灰岩和粘土为基底，是一个昼热夜凉的干燥地区。这里的酒通常浓郁而强劲。本报告中的顶级生产商包括：波里布兰奇酒庄、米其林酒庄以及杰拉德·伯特兰。",
      },
    ],
  },
};
